import range from 'lodash-es/range';


export const SAMPLE_FILE_BTN_COLORS = ["danger", "success", "info", "warning"];

export const DOCUMENT_ANALYSIS_MAX_FILE_SIZE = 20;
export const DOCUMENT_DEIDENTIFICATION_MAX_FILE_SIZE = 20;

// TODO: require 안의 경로도 변수로 사용할 수 있게 하는 방안이 있는지 확인 
export const DOCUMENT_ANALYSIS_SAMPLE_FILE_PREVIEW = "http://demo.wesome.co.kr/pdfion/sample/preview";
export const DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_NAME = "sample_pdf.zip";
export const DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_PATH = require("assets/samples/pdfion/download/"+DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_NAME);

export const DOCUMENT_DEIDENTIFICATION_SAMPLE_FILE_PREVIEW = "http://demo.wesome.co.kr/blind/sample/preview";
export const DOCUMENT_DEIDENTIFICATION_SAMPLE_DOWNLOAD_NAME = "sample_doc.zip";
export const DOCUMENT_DEIDENTIFICATION_SAMPLE_DOWNLOAD_PATH = require("assets/samples/blind/download/"+DOCUMENT_DEIDENTIFICATION_SAMPLE_DOWNLOAD_NAME);

const SPIKE_PDFion_PREVIEW_FILENAME = ["G1141311_Korea", "G1246957_Japan", "G0142657_China"];
const SPIKE_PDFion_PREVIEW_IMAGE_CNT = [17, 48, 51];
export const SPIKE_PDFion_PREVIEW_IMAGE_INFO = SPIKE_PDFion_PREVIEW_FILENAME.map( (filename, idx) => {
  const totalImageCnt = SPIKE_PDFion_PREVIEW_IMAGE_CNT[idx];
  const imageFilenames = range(1, totalImageCnt+1).map((no) => {
    return {
      original: require("assets/samples/pdfion/preview/"+filename+"/"+filename+"-"+( no < 10 ? "0":"")+no+".png")
    }
  });
  return imageFilenames;
});

const DEIDENTIFICATION_PREVIEW_FILENAME = ["sample_1", "sample_2", "sample_3", "sample_4", "sample_5"];
const DEIDENTIFICATION_PREVIEW_IMAGE_CNT = [1, 1, 11, 6, 2];
export const DEIDENTIFICATION_PREVIEW_FILE_EXTENSION = ["DOCX", "XLSX", "PPTX", "HWP", "PDF"];
export const DEIDENTIFICATION_PREVIEW_IMAGE_INFO = DEIDENTIFICATION_PREVIEW_FILENAME.map( (filename, idx) => {
  const totalImageCnt = DEIDENTIFICATION_PREVIEW_IMAGE_CNT[idx];
  const imageFilenames = range(1, totalImageCnt+1).map((no) => {
    return {
      original: require("assets/samples/blind/preview/"+filename+"/"+filename+"-"+( no < 10 ? "0":"")+no+".jpg")
    }
  });
  return imageFilenames;
});

export const DEIDENTIFICATION_ITEM_NAME = {
  KOREA_RRN: "주민등록번호",
  KOREA_PASSPORT: "여권번호",
  EMAIL_ADDRESS: "이메일",
  KOREA_PHONE_NUMBER: "전화번호",
  CUSTOM_PATTERN: "사용자 지정 패턴",
}